import React from 'react';
import { View } from 'react-native';

import { Text } from 'app/src/styles';
import Entry from 'app/src/styles/mobileTable';
import { datetimeShort } from 'app/src/utils/formatting';

const MobileRow = ({ entry, columns }) => {
  const actionColumn = columns[columns.length - 1];

  return (
    <Entry.Container>
      <View style={{ flexDirection: 'row', gap: 4, alignItems: 'center' }}>
        <Entry.Title>
          {datetimeShort(entry.createdAt)}
        </Entry.Title>
        {entry.alert && (
          <Text style={{ color: '#ff0000', fontSize: 24 }}>⚠</Text>
        )}
        {entry.dismissedAt && (
          <Text>✅</Text>
        )}
        {entry.notes.length > 0 && (
          <Text>📓</Text>
        )}
      </View>
      <Entry.Text>
        {entry.message}
      </Entry.Text>
      {actionColumn.content({ entry })}
    </Entry.Container>
  );
};

export default MobileRow;
